/**
 * DM Cart cart rules
 */
(function () {
  if (window.__dmCartRulesInitialized) return;
  window.__dmCartRulesInitialized = true;

  const RULES_SOURCE = 'dm-cart-rules';
  const dmCartRules = window.dmCartRules || {};
  const EMPTY_OBJECT = {};

  const parentSkus = new Set(
    (
      Array.isArray(dmCartRules.parentSkus)
        ? dmCartRules.parentSkus
        : String(dmCartRules.parentSkus || '').split(',')
    )
      .map(function (s) {
        return String(s).trim();
      })
      .filter(Boolean)
  );

  let enforcing = false;
  let debounceTimer = null;
  let cartRequest = null;

  function lineProperties(item) {
    return item && item.properties ? item.properties : EMPTY_OBJECT;
  }

  function propTruthy(props, key) {
    const v = props[key];
    return v === true || v === 'true' || v == 1;
  }

  function isPartLine(item) {
    const props = lineProperties(item);
    if (propTruthy(props, '_dm_cart_part')) return true;
    const addonFor = props['Add-on for'];
    return addonFor != null && String(addonFor).trim() !== '';
  }

  function isParentLine(item) {
    const props = lineProperties(item);
    if (propTruthy(props, '_dm_cart_parent')) return true;
    const sku = String(item.sku || '').trim();
    return sku !== '' && parentSkus.has(sku);
  }

  function cartHasParent(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    const items = cart.items;
    for (let i = 0; i < items.length; i++) {
      if (isParentLine(items[i])) return true;
    }
    return false;
  }

  function fetchCart() {
    if (cartRequest) return cartRequest;

    cartRequest = fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
      })
      .finally(function () {
        cartRequest = null;
      });

    return cartRequest;
  }

  function removePartLines(updates) {
    const updateUrl =
      window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js';
    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          };
    config.body = JSON.stringify({ updates: updates });
    return fetch(updateUrl, config).then(function (res) {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    });
  }

  function notifyCartRefresh(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: RULES_SOURCE,
        cartData: cartData,
      });
    }
    document.dispatchEvent(new Event('cart:updated'));
  }

  function enforceDmCartRules() {
    if (!parentSkus.size || enforcing) return Promise.resolve();

    enforcing = true;
    return fetchCart()
      .then(function (cart) {
        if (cartHasParent(cart)) return null;

        const updates = {};
        let hasUpdates = false;
        const items = cart.items || [];

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (isPartLine(item)) {
            updates[item.key] = 0;
            hasUpdates = true;
          }
        }

        if (!hasUpdates) return null;
        return removePartLines(updates);
      })
      .then(function (updatedCart) {
        if (updatedCart && updatedCart.items && !updatedCart.status) {
          notifyCartRefresh(updatedCart);
        }
      })
      .catch(function (err) {
        console.error('[dm-cart-cart-rules] enforce failed', err);
      })
      .finally(function () {
        enforcing = false;
      });
  }

  function scheduleEnforce() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      enforceDmCartRules();
    }, 120);
  }

  function onCartActivity(event) {
    if (event && event.source === RULES_SOURCE) return;
    scheduleEnforce();
  }

  /**
   * Block add when product is a DM cart part and no parent is in cart.
   * Call from product-form / quick-add before submit if needed.
   */
  function validatePartAddAllowed() {
    if (!parentSkus.size) return Promise.resolve(true);
    if (
      !document.documentElement.dataset.dmCartPartProduct &&
      !document.querySelector('[data-dm-cart-part]')
    ) {
      return Promise.resolve(true);
    }

    return fetchCart().then(function (cart) {
      if (cartHasParent(cart)) return true;
      const msg =
        dmCartRules.partsRequireParentMessage ||
        'This item is available with purchase of a DM Cart.';
      const url = dmCartRules.dmCartCollectionUrl || '/collections/dm-carts';
      if (window.confirm(msg + '\n\nView DM Carts?')) {
        window.location.href = url;
      }
      return false;
    });
  }

  window.dmCartCartRules = {
    enforce: enforceDmCartRules,
    validatePartAddAllowed: validatePartAddAllowed,
    isPartLine: isPartLine,
    isParentLine: isParentLine,
  };

  function initListeners() {
    document.addEventListener('cart:updated', onCartActivity);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartActivity);
    }
  }

  function boot() {
    initListeners();
    enforceDmCartRules();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
